'use client';

import { PenLine } from 'lucide-react';
import { useState } from 'react';

/**
 * F2 (Plan 7) — consumer-facing "想成为经济学家" upgrade entry on /discover.
 * Only rendered when /discover's server component detects role='consumer'.
 *
 * Click → POST /api/me/upgrade-to-economist → flips role + creates pending
 * application → redirect to /onboarding/apply where the existing form
 * collects credentials/domain/desired_username → admin approves via /platform.
 */
export function UpgradeBanner() {
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function upgrade() {
    setError(null);
    setPending(true);
    try {
      const res = await fetch('/api/me/upgrade-to-economist', { method: 'POST' });
      if (!res.ok) {
        setError('升级失败，请稍后再试');
        setPending(false);
        return;
      }
      const body = (await res.json().catch(() => ({}))) as { redirect_to?: string };
      window.location.href = body.redirect_to ?? '/onboarding/apply';
    } catch {
      setError('网络错误');
      setPending(false);
    }
  }

  return (
    <section className="bg-gradient-to-br from-warmth/10 to-warmth/[0.02] border border-warmth/20 rounded-2xl p-5 mb-10">
      <div className="flex items-start gap-4 flex-wrap">
        <div
          className="w-10 h-10 rounded-full bg-warmth/15 text-warmth flex items-center justify-center flex-shrink-0"
          aria-hidden
        >
          <PenLine size={18} strokeWidth={1.75} />
        </div>
        <div className="flex-1 min-w-[240px]">
          <p className="font-serif text-base text-ink mb-1">你也是经济学家吗？</p>
          <p className="text-dusk text-sm leading-relaxed">
            训练你的 AI 分身，让海外机构投资者直接跟它对话。Leon 会在 48 小时内审核申请。
          </p>
          {error && <p className="text-xs text-warmth mt-2">{error}</p>}
        </div>
        <button
          type="button"
          onClick={upgrade}
          disabled={pending}
          className="text-sm bg-warmth-dark text-white px-4 py-2 rounded-2xl hover:bg-warmth transition disabled:opacity-50 font-medium whitespace-nowrap"
        >
          {pending ? '处理中…' : '申请成为经济学家'}
        </button>
      </div>
    </section>
  );
}
